import { motion } from "framer-motion";

export default function FloatingWhatsApp() {
  return (
    <motion.a
      href="https://wa.me/918921552108"
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="floating-whatsapp-btn"
      initial={{ opacity: 0, y: 24, scale: 0.7 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.6, delay: 1.8, ease: [0.16, 1, 0.3, 1] }}
      className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-[0_14px_34px_rgba(37,211,102,0.4)] transition-transform duration-300 hover:scale-110"
    >
      <span className="ih-ping absolute inline-flex h-full w-full rounded-full bg-[#25D366]" />
      <i className="fa-brands fa-whatsapp relative text-[27px] text-white" />
    </motion.a>
  );
}
